{
  "metadata": {
    "id": "nord-dark",
    "name": "Nord",
    "description": "Портировано из темы «Nord» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "nord.json",
      "project": "nordtheme",
      "url": "https://github.com/nordtheme/nord",
      "upstreamFile": "packages/ui/src/theme/themes/nord.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 24.8,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.412,
      "paletteMaxS": 0.471,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.0,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.0,
      "syntaxVsTextMinDeltaE": 11.8,
      "chartsMinDeltaE": 25.0,
      "textSeparationDeltaE": 14.0,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "function",
          "deltaE": 15.8
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#88c0d0",
      "hover": "#96c8d6",
      "active": "#a0cdd9",
      "foreground": "#000000",
      "muted": "#88c0d080",
      "emphasis": "#88c0d0"
    },
    "surface": {
      "background": "#2e3440",
      "foreground": "#e5e9f0",
      "muted": "#404652",
      "mutedForeground": "#bec2c8",
      "elevated": "#4a505b",
      "elevatedForeground": "#e5e9f0",
      "raised": "#5e6470",
      "raisedForeground": "#e5e9f0",
      "overlay": "#2e3440cc",
      "subtle": "#373d48"
    },
    "interactive": {
      "border": "#656b76",
      "borderHover": "#616771",
      "borderFocus": "#88c0d0",
      "selection": "#e5e9f029",
      "selectionForeground": "#e5e9f0",
      "focus": "#88c0d059",
      "focusRing": "#88c0d061",
      "cursor": "#e5e9f0",
      "hover": "#e5e9f01c",
      "active": "#e5e9f029"
    },
    "status": {
      "error": "#cf8990",
      "errorForeground": "#000000",
      "errorBackground": "#cf899024",
      "errorBorder": "#cf899073",
      "warning": "#d18a74",
      "warningForeground": "#000000",
      "warningBackground": "#d18a7424",
      "warningBorder": "#d18a7473",
      "success": "#a3be8c",
      "successForeground": "#000000",
      "successBackground": "#a3be8c24",
      "successBorder": "#a3be8c73",
      "info": "#81a1c1",
      "infoForeground": "#000000",
      "infoBackground": "#81a1c124",
      "infoBorder": "#81a1c173"
    },
    "pr": {
      "open": "#a3be8c",
      "draft": "#ced1d5",
      "blocked": "#d18a74",
      "merged": "#d57780",
      "closed": "#cf8990"
    },
    "syntax": {
      "base": {
        "background": "#535964",
        "foreground": "#e5e9f0",
        "comment": "#80eaff",
        "keyword": "#b2d9ff",
        "string": "#b4e2b6",
        "number": "#ddcbd9",
        "function": "#b0d5e0",
        "variable": "#e5e9f0",
        "type": "#b1e018",
        "operator": "#d7e2cf"
      },
      "tokens": {
        "commentDoc": "#80eaff",
        "stringEscape": "#d7e2cf",
        "keywordImport": "#b2d9ff",
        "storageModifier": "#b2d9ff",
        "functionCall": "#b0d5e0",
        "method": "#b0d5e0",
        "variableProperty": "#b0d5e0",
        "variableOther": "#e5e9f0",
        "variableGlobal": "#ddcbd9",
        "variableLocal": "#d7e2cf",
        "parameter": "#e5e9f0",
        "constant": "#ddcbd9",
        "class": "#b1e018",
        "className": "#b1e018",
        "interface": "#b1e018",
        "struct": "#b1e018",
        "enum": "#b1e018",
        "typeParameter": "#b1e018",
        "namespace": "#b1e018",
        "module": "#b2d9ff",
        "tag": "#b2d9ff",
        "jsxTag": "#b2d9ff",
        "tagAttribute": "#b0d5e0",
        "tagAttributeValue": "#b4e2b6",
        "boolean": "#ddcbd9",
        "decorator": "#b2d9ff",
        "label": "#b0d5e0",
        "regexp": "#b4e2b6"
      }
    },
    "charts": {
      "series": [
        "#88c0d0",
        "#818cc1",
        "#a3be8c",
        "#d18a74",
        "#d3b7ae"
      ]
    },
    "chat": {
      "background": "#2e3440",
      "userMessage": "#eff1f6",
      "userMessageBackground": "#4a505b",
      "assistantMessage": "#e5e9f0",
      "assistantMessageBackground": "#404652",
      "timestamp": "#ced1d5",
      "divider": "#656b76",
      "typing": "#ced1d5"
    },
    "loading": {
      "spinner": "#88c0d0",
      "spinnerTrack": "#404652",
      "skeleton": "#404652",
      "shimmer": "#5c626c"
    },
    "tools": {
      "background": "#404652",
      "border": "#656b76",
      "headerHover": "#5a606b",
      "icon": "#88c0d0",
      "title": "#e5e9f0",
      "description": "#ced1d5",
      "edit": {
        "added": "#a3be8c",
        "addedBackground": "#a3be8c24",
        "removed": "#cf8990",
        "removedBackground": "#cf899024",
        "modified": "#81a1c1",
        "modifiedBackground": "#81a1c124",
        "lineNumber": "#ced1d5"
      }
    },
    "markdown": {
      "heading1": "#e5e9f0",
      "heading2": "#e5e9f0",
      "heading3": "#e5e9f0",
      "heading4": "#e5e9f0",
      "link": "#88c0d0",
      "linkHover": "#96c8d6",
      "inlineCode": "#b4e2b6",
      "inlineCodeBackground": "#404652",
      "blockquote": "#ced1d5",
      "blockquoteBorder": "#656b76",
      "listMarker": "#88c0d0bf",
      "bold": "#e5e9f0",
      "italic": "#e5e9f0e6",
      "strikethrough": "#ced1d5",
      "hr": "#656b76"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#ba5547",
        "foreground": "#ffffff",
        "contrast": 4.69
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#bc957e",
        "foreground": "#000000",
        "contrast": 7.74
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#bfa153",
        "foreground": "#000000",
        "contrast": 8.44
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#b1c358",
        "foreground": "#000000",
        "contrast": 10.82
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#cae0aa",
        "foreground": "#000000",
        "contrast": 14.75
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#57c053",
        "foreground": "#000000",
        "contrast": 9.07
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#78ce90",
        "foreground": "#000000",
        "contrast": 11.03
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#61ac97",
        "foreground": "#000000",
        "contrast": 7.86
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#b0d2d6",
        "foreground": "#000000",
        "contrast": 13.04
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#509dbd",
        "foreground": "#000000",
        "contrast": 6.9
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4773b8",
        "foreground": "#ffffff",
        "contrast": 4.76
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#4345b4",
        "foreground": "#ffffff",
        "contrast": 7.64
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a36ec7",
        "foreground": "#000000",
        "contrast": 5.61
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d4aed4",
        "foreground": "#000000",
        "contrast": 10.8
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#bb4b91",
        "foreground": "#ffffff",
        "contrast": 4.64
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#a7596f",
        "foreground": "#ffffff",
        "contrast": 4.88
      }
    ]
  }
}
